import GLOBAL from '../util/global';
import postXHR from '../util/xhr';

import Category from '../core/types/category.type';
import IMessage, { IShared } from '../core/types/message.type';
import PD from '../core/types/pd.type';

let FORMER_PD_FLAG: boolean = true;
let sharedData: IShared[] = [];

// 时间戳问题
function _sendPDData(ctx: any, padding?: object) {
    const mergedData: IMessage[] = [];
    const raw: IMessage =  ctx.inspect();

    const pd: PD = {
        duration: ctx.duration,	   // 页面停留时间
        padding: padding || {},	   // 附加信息
    };

    raw.pd = pd;
    raw.category = Category.PD;

    mergedData.push(raw);

    const postData = [{
        common: sharedData,
        body: mergedData,
    }];

    if (GLOBAL.navigator && GLOBAL.navigator.sendBeacon) {
        const content = `data=${encodeURIComponent(JSON.stringify(postData))}`;
        const requestBlob = new Blob([content], { type : 'application/x-www-form-urlencoded' });
        navigator.sendBeacon(GLOBAL.__host__ + '/api/prajna', requestBlob);
    } else {
        postXHR({
            data: encodeURIComponent(JSON.stringify(postData)),
        });
    }
}

function PDMiddleware(ctx: any, next: any): any {
    if (FORMER_PD_FLAG) {
        FORMER_PD_FLAG = false;
        sharedData = ctx.getShared();
        // 对于直接页面跳转或者关闭
        GLOBAL.addEventListener("beforeunload", () => {
            _sendPDData(ctx);
        });
        // 对于单页应用使用路由的情况
        GLOBAL.addEventListener("hashchange", () => {
            _sendPDData(ctx);
        });
    }
    next();
}
export default PDMiddleware;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./node_modules/tslint-loader??ref--1!./src/middleware/pd-middleware.ts